




































































































































/* eslint-disable @typescript-eslint/camelcase */
import { Component, Vue, Watch } from 'vue-property-decorator';
import dayjs from 'dayjs';

import SearchIcon from 'mdi-vue/Magnify';
import ExportIcon from 'mdi-vue/FileExportOutline';
import PlusIcon from 'mdi-vue/Plus';

import LayoutTitle from '@/components/LayoutTitle.vue';
import LayoutContent from '@/components/LayoutContent.vue';
import Tab from '@/components/Tab/Tab.vue';
import Button from '@/components/Button.vue';
// import DatePicker, { DateRange } from '@/components/DatePicker.vue';

import Accordion from '@/components/Accordion.vue';
import FormInput from '@/components/FormInput.vue';
import SearchRow from '@/components/SearchRow.vue';
import SearchField from '@/components/SearchField.vue';
import Select from '@/components/Select.vue';
import Modal from '@/components/Modal.vue';
import Toggle from '@/components/Toggle.vue';
import api, { apiProduction, apiSandbox } from '@/libs/api';
// eslint-disable-next-line import/no-cycle
// import { showToast } from '@/libs/toast';
// import { ToastType } from '@/store/toast';
import ReportTable from './BalanceListTable.vue';
import MerchantBalanceBox from './components/MerchantBalanceBox.vue';
// import BalanceBox from './components/MerchantBalanceBox.vue';

@Component({
  components: {
    LayoutTitle,
    Button,
    LayoutContent,
    Tab,
    ReportTable,
    Accordion,
    SearchIcon,
    ExportIcon,
    PlusIcon,
    SearchRow,
    SearchField,
    Select,
    Modal,
    Toggle,
    FormInput,
    MerchantBalanceBox,
  },
})
export default class BalanceList extends Vue {
  $refs!: {
    report: ReportTable;
  }

  yearData = [];
  totalBalance = 0;
  searchOpen = false;

  merchantName = '';
  merchantCode = '';
  export = false;

  statusOptions = [
    { label: 'ACTIVE', value: 'ACTIVE' },
    { label: 'INACTIVE', value: 'INACTIVE' },
  ];

  status: { label: string; value: string } | null = null;
  year: { label: string; value: string } | null = null;

  loadingExport = false;

  mounted() {
    this.parseParams();
  }

  @Watch('$route')
  onRouteChange() {
    this.parseParams();
  }

  async getTransaction() {
    const params = {
      merchant: this.merchantName,
      merchant_code: this.merchantCode,
      year: this.year,
      status: this.status,
      export: this.export,
    };
    await this.$refs.report.getTransaction(params);
  }

  async exportTransaction() {
    const params = {
      merchant: this.merchantName,
      merchant_code: this.merchantCode,
      year: this.year,
      status: this.status,
      export: true,
    };

    this.loadingExport = true;
    await this.$refs.report.export(params);
    this.loadingExport = false;
  }

  totalBalanceF(val: number) {
    this.totalBalance = val;
  }

  yearDataF(val: any) {
    this.yearData = val;
  }

  parseParams() {
    const params = this.$route.query;
    // console.log(params);
    if (typeof params.status === 'string') {
      const status = {
        label: params.status,
        value: params.status,
      };

      this.status = status;
    } else {
      this.status = null;
    }

    if (typeof params.year === 'string') {
      const year = {
        label: params.year,
        value: params.year,
      };

      this.year = year;
    } else {
      this.year = null;
    }

    // eslint-disable-next-line @typescript-eslint/camelcase
    if (typeof params.merchant_name === 'string') {
      // eslint-disable-next-line @typescript-eslint/camelcase
      const { merchant_name } = params;
      // eslint-disable-next-line @typescript-eslint/camelcase
      this.merchantName = merchant_name;
    } else {
      this.merchantName = '';
    }

    this.getTransaction();
  }

  toggleSearchOpen() {
    this.searchOpen = !this.searchOpen;
  }

  search() {
    // console.log('IN HIT');
    this.$router.push({
      query: {
        status: this.status === null ? undefined : this.status.value,
        year: this.year === null ? undefined : this.year.value,
        merchant_name: this.merchantName === '' ? undefined : this.merchantName,
        merchant_code: this.merchantCode === '' ? undefined : this.merchantCode,
      },
    });
  }

  cancel() {
    this.status = null;
    this.merchantName = '';
    this.merchantCode = '';
    this.year = null;

    this.$router.push({
      query: {},
    });
  }
}
